import { RootState } from '../../rootReducer';

export const searchSelectors = {
  getSearchData: (state: RootState) => state.SearchState,
};
